module.exports = __webpack_public_path__ + "065384b620091b2f127bb57f4748ac6d.pdf";